import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ICondition } from '@ahryman40k/ts-fhir-types/lib/R4';
import { AbstractDetailsComponent } from '../../../shared/abstracts/details/abstract-details/abstract-details.component';

@Component({
  selector: 'inc-condition-details',
  templateUrl: './condition-details.component.html',
  styleUrls: ['./condition-details.component.scss'],
})
export class ConditionDetailsComponent extends AbstractDetailsComponent<{ condition: ICondition, files: File[] }> implements OnInit {
  condition: ICondition;
  files: File[];
  @Output() callOpenFile = new EventEmitter<number>();

  constructor() {
    super();
  }

  ngOnInit() {
    if (this.inData) {
      this.condition = this.inData.condition ? this.inData.condition : null;
      this.files = this.inData.files ? this.inData.files : [];
    }
  }

  openFile(i: number) {
    this.callOpenFile.emit(i);
  }
}
